import React from 'react';
import PropTypes from 'prop-types';
import { DropdownProvider } from './context';
import Dropdown from './Dropdown';
import DropdownBody from './Dropdown/DropdownBody/DropdownBody';
import DropdownButton from './Dropdown/DropdownButton';
import { DropdownTypes } from './helper';
import '@dtsl/css-utilities/dist/auto-positions/index.css';
function DropdownWrapper(props) {
  const {
    label,
    value,
    isError,
    readonly,
    disabled,
    removeTag,
    className,
    tooltipData,
    placeHolder,
    inputStyles,
    isSearchable,
    labelRequired,
    controlClassName,
    placeholderClassName,
    specificationText,
    arrowClassName,
    inlineDropdownStyles,
    isDropdownButton,
    dropdownButtonMetaData,
    dropdownType,
    isMobile,
    dataTestId,
    isAbsoluteDropdown,
    placement
  } = props;
  return /*#__PURE__*/React.createElement(DropdownProvider, {
    value: value,
    isMobile: isMobile,
    placeHolder: placeHolder,
    placement: placement
  }, /*#__PURE__*/React.createElement(Dropdown, {
    label: label,
    isError: isError,
    disabled: disabled,
    className: className,
    inputStyles: inputStyles,
    placeHolder: placeHolder,
    isSearchable: isSearchable,
    labelRequired: labelRequired,
    isDropdownButton: isDropdownButton,
    specificationText: specificationText,
    inlineDropdownStyles: inlineDropdownStyles,
    isAbsoluteDropdown: isAbsoluteDropdown,
    placement: placement
  }, /*#__PURE__*/React.createElement(DropdownButton, {
    readonly: readonly,
    disabled: disabled,
    removeTag: removeTag,
    tooltipData: tooltipData,
    placeHolder: placeHolder,
    dropdownType: dropdownType,
    isSearchable: isSearchable,
    arrowClassName: arrowClassName,
    isDropdownButton: isDropdownButton,
    controlClassName: controlClassName,
    inputStyles: inputStyles,
    placeholderClassName: placeholderClassName,
    dropdownButtonMetaData: dropdownButtonMetaData,
    dataTestId: dataTestId
  }), /*#__PURE__*/React.createElement(DropdownBody, props)));
}
DropdownWrapper.defaultProps = {
  label: '',
  value: [],
  isError: false,
  readonly: false,
  disabled: false,
  className: '',
  placement: '',
  inputStyles: {},
  tooltipData: {},
  arrowClassName: '',
  controlClassName: '',
  removeTag: () => {},
  isSearchable: false,
  labelRequired: false,
  specificationText: '',
  placeholderClassName: '',
  inlineDropdownStyles: {},
  isDropdownButton: false,
  dropdownButtonMetaData: {},
  dropdownType: DropdownTypes.SINGLE_SELECTION,
  placeHolder: 'Select a condition',
  isMobile: false,
  dataTestId: '',
  isAbsoluteDropdown: false,
  autoPlacement: false
};
DropdownWrapper.propTypes = {
  label: PropTypes.string,
  isError: PropTypes.bool,
  value: PropTypes.array,
  disabled: PropTypes.bool,
  readonly: PropTypes.bool,
  removeTag: PropTypes.func,
  className: PropTypes.string,
  placement: PropTypes.string,
  placeHolder: PropTypes.string,
  inputStyles: PropTypes.object,
  tooltipData: PropTypes.object,
  isSearchable: PropTypes.bool,
  labelRequired: PropTypes.bool,
  isDropdownButton: PropTypes.bool,
  arrowClassName: PropTypes.string,
  controlClassName: PropTypes.string,
  specificationText: PropTypes.string,
  placeholderClassName: PropTypes.string,
  inlineDropdownStyles: PropTypes.object,
  dropdownButtonMetaData: PropTypes.object,
  dropdownType: PropTypes.string,
  isMobile: PropTypes.bool,
  dataTestId: PropTypes.string,
  isAbsoluteDropdown: PropTypes.bool,
  autoPlacement: PropTypes.bool
};
export default DropdownWrapper;